import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, withModifiers as _withModifiers, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "aria-disabled"]

import { useDropdownItem } from '@components/RcDropdown/useDropdownItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownItem',
  props: { disabled: Boolean },
  emits: ['click'],
  setup(__props, { emit: __emit }) {

/**
 * An item for a dropdown menu. Used in conjunction with RcDropdown.
 */
const props = __props;
const emits = __emit;

const {
  handleKeydown,
  close,
  handleActivate,
  scrollIntoView,
} = useDropdownItem();

const handleClick = (e: MouseEvent) => {
  if (props.disabled) {
    return;
  }

  emits('click', e);
  close();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "dropdownMenuItem",
    "dropdown-menu-item": "",
    tabindex: "-1",
    role: "menuitem",
    disabled: __props.disabled || null,
    "aria-disabled": __props.disabled || false,
    onClick: _withModifiers(handleClick, ["stop"]),
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleActivate) && _unref(handleActivate)(...args)), ["enter","space"])),
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(handleKeydown) && _unref(handleKeydown)(...args)), ["prevent","stop"]), ["up","down"]))
    ],
    onMousedown: _withModifiers(() => {/*We use this to prevent clicks from triggering the @focusin below. When we scroll on a click it prevents the action from occurring on the first click.*/}, ["prevent"]),
    onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollIntoView) && _unref(scrollIntoView)(...args)))
  }, [
    _renderSlot(_ctx.$slots, "before"),
    _cache[3] || (_cache[3] = _createTextVNode()),
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})